import {useState} from 'react';
import { Button } from '@mui/material'

const CustomSwitch = ({firstOption, secondOption, onChange}) => {
    const [activeOpt, setActiveOpt] = useState(firstOption);

    const handleToggleView = (option) => {
        setActiveOpt(option);
        onChange && onChange(option)
    };

    return (
        <div>
            <Button
                variant={activeOpt === firstOption ? 'contained' : 'outlined'}
                style={{borderBottomLeftRadius: 30, borderTopLeftRadius: 30, borderBottomRightRadius: 0, borderTopRightRadius: 0}}
                onClick={() => handleToggleView(firstOption)}
            >
                {firstOption}
            </Button>
            <Button
                variant={activeOpt === secondOption ? 'contained' : 'outlined'}
                style={{borderBottomLeftRadius: 0, borderTopLeftRadius: 0, borderBottomRightRadius: 30, borderTopRightRadius: 30}}
                onClick={() => handleToggleView(secondOption)}
            >
                {secondOption}
            </Button>

        </div>
    );
};

export default CustomSwitch;